import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Alert, Button, Container } from "@mui/material";

import { IDocument } from "../../../types/document";

import { useUserContext } from "../../../contexts/userContext";
import { AppConfig } from "../../../config/appConfig";
import { DocumentService } from "../../../services/documentService";

import Navigation from "../../header";
import PermissionGate from "../../permissionGate";
import DocumentTable from "../../tables/documentTable";
import DocumentViewer from "../../documentViewer";

import "../../../styles/entity/documentList.scss";

const DocumentList = () => {
	const userContext = useUserContext();
	const navigate = useNavigate();
	const [gridView, setGridView] = useState<IDocument[] | undefined>(undefined);
	
	const [isLoadingDocuments, setIsLoadingDocuments] = useState(false);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();
	const [viewingDocumentId, setViewingDocumentId] = useState<number | undefined>(undefined);
	
	const loadDocuments = async () => {
		setIsLoadingDocuments(true);
		setErrorMessage(undefined);

		DocumentService.getDocuments()
			.then((response) => {
				console.log('DocumentService.getDocuments: SUCCESS', response);
				let documents = DocumentService.mapDocuments(response.data);
				setGridView(documents);
			})
			.catch((error) => {
				console.log('DocumentService.getDocuments: ERROR', error);
				if (error?.code == "ERR_NETWORK") {
					setErrorMessage(AppConfig.apiConnectionErrorMessage)
				}
			})
			.finally(() => {
				setIsLoadingDocuments(false);
			});
	}

	const handleDocumentDeleted = (id: number) => {
		setGridView(gridView.filter(doc => doc.id !== id));
	}

	useEffect(() => {
		loadDocuments();
	}, [])
	
    return (
        <div className="hwi-document-list">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageDocuments}>
					<section className={`hwi-entity-search-bar ${viewingDocumentId ? "hidden" : ""}`}>
						<div className="search-header">
							<div className="title">Search Documents</div>
							<div><NavLink to="/document/add"><Button variant="outlined">New Document</Button></NavLink></div>
						</div>
					</section> 
					<section className={`results ${viewingDocumentId ? "hidden" : ""}`}>
						{errorMessage &&
							<Alert className="alert-error"
								severity="error">
								{errorMessage}
							</Alert>
						}
						{!errorMessage &&
							<DocumentTable 
								data={gridView} 
								isLoading={isLoadingDocuments} 
								onRequestListRefresh={loadDocuments}
								onViewDocument={(id) => { setViewingDocumentId(id) }} 
								onDocumentDeleted={(id) => { handleDocumentDeleted(id) }}
							></DocumentTable>
						}
					</section>
					{viewingDocumentId &&
						<DocumentViewer documentId={viewingDocumentId} showBackButton={true} onCloseRequest={() => setViewingDocumentId(undefined)}></DocumentViewer>						
					}
				</PermissionGate>
			</Container>
		</div>
    );
};

export default DocumentList;